<div class="watchFace">
  <img class="topIcon" src="assets/images/activities/run_icon.png" *ngIf="activity.type==='Run'||activity.type==='VirtualRun'">
  <img class="topIcon" src="assets/images/activities/cycling_icon.png" *ngIf="activity.type==='Ride'||activity.type==='VirtualRide'">
  <img class="topIcon" src="assets/images/activities/swim_icon.png" *ngIf="activity.type==='Swim'">
  <div class="watchFaceTopHalf">{{activity.distance | distance : 'show'}}</div>
  <div class="watchFaceBottomHalf">
    <div class="watchFaceBottomLeft">
      <app-polyline-map [width]="'15vw'" [height]="'15vw'" [mapId]="'watchFaceId'" *ngIf="activity.map?.polyline||activity.map?.summary_polyline" [polyline]="activity.map?.summary_polyline" [type]="activity.type"></app-polyline-map>
    </div>
    <div class="watchFaceBottomRight">
      {{activity.moving_time | elapsed}}
      <br>
      {{activity.pace | elapsed : unit }}
    </div>
  </div>
</div>
